import axios from "axios";
const endpoint = process.env.VUE_APP_BASE_API + "/api/master/tariff/transfer";
export default {
  async getMasterClassname(fareCategory) {
    return await axios
      .get(endpoint + `?fareCategory=${fareCategory}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getListRate(filter) {
    return await axios
      .get(endpoint + `/search${filter}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getListRateProvider(filter) {
    return await axios
      .get(endpoint + `/subscription${filter}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getCommon(isSelfDrive) {
    return await axios
      .get(endpoint + `/common?selfDrive=${isSelfDrive}`)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async create(request) {
    return await axios
      .post(endpoint, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async update(request) {
    return await axios
      .put(endpoint, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async subscription(request) {
    return await axios
      .put(endpoint + "/subscription", request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async activation(request) {
    return await axios
      .put(endpoint + "/activation", request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async delete(request) {
    return await axios
      .delete(endpoint, { data: request })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/master/transferTariff/transferTariffService.js